import React from 'react';
import I18n from 'i18n-js';
import { RCIcon, RCLoadingBars, RCPopover } from '@reverbdotcom/cadence/components';
import { BellIcon } from '@reverbdotcom/cadence/icons/react';
import { useNotificationsBellCount } from './notifications_bell_count_hook';
import { trackEvent } from '@reverbdotcom/commons/src/elog/mparticle_tracker';
import { MParticleEventName } from '@reverbdotcom/commons/src/elog/mparticle_types';

export const COMPONENT_NAME = 'NotificationsCenterPopover';

export default function NotificationsCenterPopover() {
  const { count } = useNotificationsBellCount();
  const [isOpen, setIsOpen] = React.useState(false);

  function handleOpenChange(open: boolean) {
    if (open) {
      trackEvent({
        eventName: MParticleEventName.OpenedNotificationPanel,
        componentName: COMPONENT_NAME,
      });
    }

    setIsOpen(open);
  }

  return (
    <RCPopover
      isOpen={isOpen}
      onOpenChange={handleOpenChange}
      position="bottom-end"
      size="large"
      sticky
      anchor={(
        <button
          type="button"
          className="reverb-header__nav__link reverb-header__nav__link--notification-icon"
        >
          <div
            className="reverb-header__nav__link__icon"
            data-notification-count={count || null}
          >
            <RCIcon icon={<BellIcon />} />
          </div>
          <div className="reverb-header__nav__link__label">
            {I18n.t('discovery.reverbHeader.notifications')}
          </div>
          <span className="reverb-header__count-badge">
            {count > 0 && I18n.t('discovery.reverbHeader.notificationCount', { count })}
          </span>
        </button>
      )}
    >
      <div className="d-flex fx-justify-center ptb-8" data-testid="notifications-center-placeholder">
        <RCLoadingBars />
      </div>
    </RCPopover>
  );
}
